const DEFAULT_SCANNER_URL = 'downloads/KellerSS.exe';

function renderReleaseDate(timeElement, date) {
  const formattedDate = new Intl.DateTimeFormat('es-MX', {
    timeZone: 'America/Mexico_City',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(date);

  timeElement.dateTime = date.toISOString();
  timeElement.dataset.releaseLabel = formattedDate;
  timeElement.textContent = '';
  timeElement.setAttribute('aria-label', formattedDate);
}

async function requestPublishedRelease(scannerUrl) {
  const releaseUrl = new URL(scannerUrl, document.baseURI);
  releaseUrl.searchParams.set('release-check', Date.now().toString(36));

  const response = await fetch(releaseUrl.href, {
    method: 'HEAD',
    cache: 'no-store',
    headers: {
      'Cache-Control': 'no-cache',
    },
  });

  if (!response.ok) {
    throw new Error('Scanner release request failed with ' + response.status);
  }

  const lastModified = response.headers.get('Last-Modified');
  const releaseDate = new Date(lastModified || '');

  if (!lastModified || !Number.isFinite(releaseDate.getTime())) {
    throw new Error('Scanner release date is unavailable');
  }

  return releaseDate;
}

export default function initScannerRelease() {
  const timeElement = document.querySelector('.tool-release time');
  if (!timeElement) return;

  const scannerUrl = timeElement.dataset.releaseUrl || DEFAULT_SCANNER_URL;

  requestPublishedRelease(scannerUrl)
    .then((releaseDate) => renderReleaseDate(timeElement, releaseDate))
    .catch(() => {
      const fallbackLabel = String(timeElement.dataset.releaseLabel || '').trim();
      if (fallbackLabel) {
        timeElement.setAttribute('aria-label', fallbackLabel);
      }
    });
}
